import React, { useState } from "react";

import Button from "../../UI/Button";
import images from "../../../utils/images";
import { Select } from "../../UI/StyledInput";

import "./styles.scss";

const MEMBER_CANCELLATION_OPTIONS = [
  { display: "Conflict with time", value: "conflict_with_time" },
  { display: "Illness/medical", value: "illness_medical" },
  { display: "Need sooner appointment", value: "need_sooner_appointment" },
  { display: "Other", value: "other" },
];

const ScheduleReviewDialog = (props) => {
  const { callId, cancelHandler, providerName, submitHandler } = props;
  const [cancellationReason, setCancellationReason] = useState(null);

  const handleRadioChange = (event) => {
    setCancellationReason(event.target.value);
  };

  const renderCancelReasonsMobile = () => {
    return (
      <div className="CancelReasonsMobile">
        <Select
          changeHandler={(reason) => setCancellationReason(reason.target.value)}
          name="cancelReason"
          options={MEMBER_CANCELLATION_OPTIONS}
          value={cancellationReason}
        />
      </div>
    );
  };
  const isCanceledButtonDisabled = cancellationReason === null;
  const renderCancelReasonsDesktop = () => {
    return (
      <div className="CancelReasonsDesktop">
        {MEMBER_CANCELLATION_OPTIONS.map((element) => {
          return (
            <div className="text-left mt-2" key={element.value}>
              <input
                checked={cancellationReason === element.value}
                className="mr-2"
                onChange={(event) => setCancellationReason(event.target.value)}
                type="radio"
                value={element.value}
              />
              <label className="fs-14">{element.display}</label>
            </div>
          );
        })}
      </div>
    );
  };

  const submit = () => {
    const data = {
      callId: callId,
      cancellation_reason: {
        reason_type: cancellationReason,
      },
    };

    submitHandler(data);
  };

  return (
    <>
      <div className="row CancelReviewContainer">
        <div className="col">
          <h2 className="fs-17 tw:font-bold">
            To cancel your appointment with {providerName} select a reason.
          </h2>
        </div>
      </div>
      <Button className="close modal-close" onClick={cancelHandler} type="button">
        <span aria-hidden="true">
          <img src={images("./icons/grey-x-circle.svg")} />
        </span>
      </Button>
      <div className="row d-flex flex-column">
        <div className="col">
          {renderCancelReasonsDesktop()}
          {renderCancelReasonsMobile()}
        </div>
        <div className="mt-4">
          <Button
            className="Btn Btn--pri Btn-sm"
            disabled={isCanceledButtonDisabled}
            onClick={submit}
            type="button"
          >
            Cancel Appointment
          </Button>
        </div>
      </div>
    </>
  );
};

export default ScheduleReviewDialog;
